export default "__VITE_ASSET__CLmUKR6r__"